/**
 * Gets the appropriate button text for confirmation buttons with fallback logic.
 *
 * @param t - The translation function from useTranslation
 * @param i18n - The i18n instance from useTranslation
 * @param defaultKey - The default translation key to use if no confirmText provided
 * @param confirmText - The custom text to use (optional)
 * @returns The appropriate button text
 */
export const getConfirmButtonText = (
    t: (key: string) => string,
    i18n: { exists: (key: string) => boolean },
    defaultKey = 'wizard:next',
    confirmText?: string,
): string => {
    if (!confirmText) {
        return t(defaultKey);
    }

    if (!i18n.exists(`wizard:${confirmText}`)) {
        return confirmText;
    }

    return t(`wizard:${confirmText}`);
};
